import Immutable from 'seamless-immutable';
import AutoManualCompleteAddress from '@common/AutocompleteOrManualAddress';
import { ACTIONS } from './actions';
import { getInitialProjectAddress } from '../utils';

const { ADDRESS_INPUT_MODES } = AutoManualCompleteAddress;

export const initialState = Immutable.from({
  address: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    stateOrProvince: '',
    postalCode: '',
    country: '',
  },
  addressInputMode: ADDRESS_INPUT_MODES.MANUAL,
  autocompletedAddress: '',
  endDate: null,
  isMapboxTokenActive: false,
  isSaving: false,
  jobNumber: '',
  missingRequiredField: true,
  projectDataChanged: false,
  projectName: '',
  projectValue: '',
  selectedCurrency: { value: 'USD' },
  selectedPhase: null,
  selectedProjectType: null,
  selectedTimeZone: null,
  showDuplicateNameError: false,
  showInvalidProjectValueError: false,
  showModalConfirmation: false,
  startDate: null,
});

export const editProjectInitialState = (project) =>
  Immutable.merge(initialState, {
    projectName: project.name,
    autocompletedAddress: getInitialProjectAddress(project),
    startDate:
      project.startDate !== '' && project.startDate !== null
        ? new Date(new Date(`${project.startDate}T00:00:00`).getTime())
        : null,
    endDate:
      project.endDate !== '' && project.endDate !== null
        ? new Date(new Date(`${project.endDate}T00:00:00`).getTime())
        : null,
    selectedProjectType: project.type !== '' ? { value: project.type } : null,
    address: {
      addressLine1: project.addressLine1 ? project.addressLine1 : '',
      addressLine2: project.addressLine2 ? project.addressLine2 : '',
      city: project.city ? project.city : '',
      stateOrProvince: project.stateOrProvince ? project.stateOrProvince : '',
      postalCode: project.postalCode ? project.postalCode : '',
      country: project.country ? project.country : '',
    },
    jobNumber: project.jobNumber,
    selectedTimeZone:
      project.timezone !== null ? { value: project.timezone } : null,
    projectValue: project.projectValue.value,
    selectedCurrency:
      project.projectValue.currency !== ''
        ? { value: project.projectValue.currency }
        : null,
  });

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.RESET_ADDRESS:
      return state.merge({
        autocompletedAddress: '',
        address: initialState.address,
      });
    case ACTIONS.RESET_EDIT_INPUT_STATE:
      return editProjectInitialState(action.payload).merge({
        isMapboxTokenActive: state.isMapboxTokenActive,
        addressInputMode: state.addressInputMode,
      });
    case ACTIONS.SET_ADDRESS:
      return state.set('address', action.payload);
    case ACTIONS.SET_ADDRESS_INPUT_MODE:
      return state.set('addressInputMode', action.payload);
    case ACTIONS.SET_AUTOCOMPLETED_ADDRESS:
      return state.set('autocompletedAddress', action.payload);
    case ACTIONS.SET_CURRENCY:
      return state.set('selectedCurrency', action.payload);
    case ACTIONS.SET_END_DATE:
      return state.set('endDate', action.payload);
    case ACTIONS.SET_IS_SAVING:
      return state.set('isSaving', action.payload);
    case ACTIONS.SET_JOB_NUMBER:
      return state.set('jobNumber', action.payload);
    case ACTIONS.SET_MAPBOX_TOKEN_ACTIVE:
      return state.set('isMapboxTokenActive', action.payload);
    case ACTIONS.SET_MISSING_REQUIRED_FIELD:
      return state.set('missingRequiredField', action.payload);
    case ACTIONS.SET_PHASE:
      return state.set('selectedPhase', action.payload);
    case ACTIONS.SET_PROJECT_DATA_CHANGED:
      return state.set('projectDataChanged', action.payload);
    case ACTIONS.SET_PROJECT_NAME:
      return state.set('projectName', action.payload);
    case ACTIONS.SET_PROJECT_VALUE:
      return state.merge({
        showInvalidProjectValueError: false,
        projectValue: action.payload,
      });
    case ACTIONS.SET_SELECTED_PROJECT_TYPE:
      return state.set('selectedProjectType', action.payload);
    case ACTIONS.SET_SHOW_DUPLICATED_NAME_ERROR:
      return state.set('showDuplicateNameError', action.payload);
    case ACTIONS.SET_SHOW_INVALID_PROJECT_VALUE_ERROR:
      return state.merge({
        showInvalidProjectValueError: true,
        projectValue: '',
      });
    case ACTIONS.SET_SHOW_MODAL_CONFIRMATION:
      return state.set('showModalConfirmation', action.payload);
    case ACTIONS.SET_START_DATE:
      return state.set('startDate', action.payload);
    case ACTIONS.SET_TIME_ZONE:
      return state.set('selectedTimeZone', action.payload);
    default:
      return state;
  }
};
